export default __webpack_public_path__ + "5717777fde7f4fa912a4c28a1c0620e1.svg";